import { hexA } from "./color";

export interface GlitchOpts {
  accent: string;
  glitchIntensity: number;
}

export class EmbiGlitch {
  private ambient: ReturnType<typeof setInterval> | null = null;
  private timers = new Set<ReturnType<typeof setTimeout>>();
  private stopped = false;
  constructor(
    private el: HTMLElement,
    private opts: GlitchOpts,
  ) {}

  private later(fn: () => void, ms: number): void {
    const id = setTimeout(() => {
      this.timers.delete(id);
      if (!this.stopped) fn();
    }, ms);
    this.timers.add(id);
  }
  private rnd(a: number, b: number): number {
    return a + Math.random() * (b - a);
  }

  intro(): void {
    const acc = this.opts.accent;
    const cols = ["#3fd6e6", "#ff6a4d", "#8a7bff", acc];
    let n = 0;
    const N = 18;
    const step = () => {
      const el = this.el;
      if (!el || this.stopped) return;
      if (n >= N) {
        this.rest();
        this.ambient = setInterval(() => {
          if (Math.random() < 0.12 + 0.35 * this.opts.glitchIntensity) this.burst();
        }, 650);
        return;
      }
      const k = 1 - n / N;
      el.style.transform = `translate(${(this.rnd(-9, 9) * k).toFixed(1)}px,${(this.rnd(-3, 3) * k).toFixed(1)}px) skewX(${(this.rnd(-13, 13) * k).toFixed(1)}deg)`;
      const c1 = cols[(Math.random() * cols.length) | 0],
        c2 = cols[(Math.random() * cols.length) | 0];
      el.style.textShadow = `${(6 * k + 1).toFixed(1)}px 0 ${c1}, -${(6 * k + 1).toFixed(1)}px 0 ${c2}, 0 0 ${(13 * k).toFixed(0)}px ${hexA(acc, 0.5 * k)}`;
      el.style.color = n % 3 === 0 ? acc : "#efe9da";
      el.style.opacity = Math.random() < 0.3 * k ? (0.5 + 0.5 * Math.random()).toFixed(2) : "1";
      n++;
      this.later(step, this.rnd(45, 95));
    };
    step();
  }

  rest(): void {
    const el = this.el;
    if (!el) return;
    el.style.transform = "none";
    el.style.opacity = "1";
    el.style.color = "#efe9da";
    el.style.textShadow = "0.6px 0 rgba(63,214,230,0.4), -0.6px 0 rgba(255,106,77,0.4)";
  }

  private burst(): void {
    const el = this.el;
    if (!el || this.stopped) return;
    const acc = this.opts.accent;
    const frames = [
      () => {
        el.style.transform = "translate(-3px,1px) skewX(-7deg)";
        el.style.textShadow = `4px 0 #3fd6e6, -4px 0 #ff6a4d, 0 0 10px ${hexA(acc, 0.55)}`;
        el.style.color = acc;
      },
      () => {
        el.style.transform = "translate(3px,-1px) skewX(4deg)";
        el.style.textShadow = "-5px 0 #8a7bff, 5px 0 #3fd6e6";
        el.style.color = "#efe9da";
      },
      () => {
        el.style.transform = "translate(-1px,0)";
        el.style.textShadow = "2px 0 #ff6a4d, -2px 0 #3fd6e6";
      },
      () => {
        this.rest();
      },
    ];
    let i = 0;
    const run = () => {
      if (i >= frames.length || this.stopped) return;
      frames[i]();
      i++;
      this.later(run, 40 + Math.random() * 45);
    };
    run();
  }

  stop(): void {
    this.stopped = true;
    if (this.ambient) {
      clearInterval(this.ambient);
      this.ambient = null;
    }
    this.timers.forEach(clearTimeout);
    this.timers.clear();
  }
}
